import { HelpCircle } from 'lucide-react'
import { Button } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './sidebarMessages'

/**
 * Прогон исчез на бэке (`404 job_not_found` / `403 job_not_author`): поллер
 * выбросил запись реестра, а вместе с ней инвариант `chatSlice` унёс историю
 * чата. Без этой плашки реплика автора и лента событий пропадают молча — самое
 * пугающее, что может случиться с экраном, за который заплатили (M-6).
 *
 * Не тост: `ai/jobs/{id}` лежит в `SILENT_ENDPOINTS` намеренно (опрос раз в три
 * секунды не должен сыпать тостами поверх работы), да и объяснять пропажу надо
 * там, где она произошла.
 */
export const JobLostNotice = ({ onDismiss }: { onDismiss: () => void }) => {
  const m = useMessages(messages)
  return (
    <div
      data-testid="job-lost-notice"
      role="status"
      className="m-3 space-y-2.5 rounded-2xl border border-border bg-card p-4 text-sm"
    >
      <div className="flex items-center gap-2">
        <HelpCircle className="h-5 w-5 shrink-0 text-muted-foreground" />
        <span className="font-medium text-foreground">{m.jobLostTitle}</span>
      </div>
      <p className="text-xs text-muted-foreground">{m.jobLostText}</p>
      <Button variant="outline" size="sm" className="w-full" onClick={onDismiss}>
        {m.gotIt}
      </Button>
    </div>
  )
}
